import { Dimensions, Platform, StatusBar } from 'react-native'

import { palette } from '../../theme/palette'

const { height, width } = Dimensions.get('window')
const BACK_BUTTON_HEIGHT = 26

export type ZogoConfig = {
  moduleId?: number
  zogoToken?: string
  baseUrl?: string
}

const ZOGO_DEV_URL = process.env.EXPO_PUBLIC_ZOGO_DEV_URL || ''
const ZOGO_STAGE = process.env.EXPO_PUBLIC_ZOGO_STAGE || 'dev'

const zogoConfigDev: ZogoConfig = {
  moduleId: 1,
  zogoToken: 'ZOGO-DEV-TOKEN', // to get the zogo token from dev environment, refer to this https://zogofinance.notion.site/Access-Tokens-8ef18e95c764488dba78af335d27eff6
  baseUrl: ZOGO_DEV_URL
}

const getZogoConfig = (config: ZogoConfig) => {
  if (Platform.OS === 'web') {
    return {
      ...config,
      baseUrl: 'https://integration.zogofinance.com'
    }
  }
  if (ZOGO_STAGE === 'prod') return config
  return zogoConfigDev
}

export const calculateZogoInsets = (topInsets: number, bottomInsets: number) => {
  return topInsets + BACK_BUTTON_HEIGHT + (bottomInsets ? 24 : 0)
}

export const getHTML = (zogoConfig: ZogoConfig, insets: number) => {
  const { zogoToken, moduleId, baseUrl } = getZogoConfig(zogoConfig)

  console.log({ zogoConfig: getZogoConfig(zogoConfig), zogoConf: zogoConfig })

  const WIDGET_TYPE = 'deep_link' // learn_and_earn || deep_link  || anon_deep_link
  const TOKEN = zogoToken // The unique user token you have retrieved from the Zogo API (required for learn_and_earn and deep_link)
  const MODULE_ID = moduleId // the module id of the module being deep linked to (required for deep_link and anon_deep_link)
  const INSTITUTION_ID = null // your institution id (required for anon_deep_link)
  const BASE_URL = baseUrl
  console.log('ZOgo config: ', ZOGO_STAGE, zogoConfig)
  const statusBarHeight = StatusBar.currentHeight || 0
  // PRELOADER CUSTOMIZATIONS
  const ALTERNATIVE_PRELOADER_IMAGE = null //'https://ppwr.io/images/Blank-Home_Purple.png' // provide an image url to change the default preloader image
  const ALTERNATIVE_PRELOADER_BACKGROUND_COLOR = 'rgba(123, 4, 61, 1)' // should match the background color of the preloader image
  // SIZE CUSTOMIZATIONS
  const IFRAME_WIDTH = `${Platform.OS === 'web' ? (width > 600 ? 600 : width) : width}px` // minimum value: 365px
  const IFRAME_HEIGHT = `${height - insets - statusBarHeight}px` // minimum value: 580px
  // DEEP LINK CUSTOMIZATONS
  const COMPLETION_MESSAGE = null
  const COMPLETION_ICON = null // should be image url
  const BANNER_IMAGE = null // should be image url
  const BANNER_ACTION_TYPE = 'post-mesage' // "post-message" || "url"
  const BANNER_ACTION_VALUE = 'banner clicked'
  const CTA_TEXT = 'You finished the module!'
  const CTA_BUTTON_TEXT = 'continue'
  const CTA_ACTION_TYPE = 'post-message' // "post-message" || "url"
  const CTA_ACTION_VALUE = 'module complete'

  const deepLinkCustomizations = {
    cm: COMPLETION_MESSAGE,
    ci: COMPLETION_ICON,
    bi: BANNER_IMAGE,
    bat: BANNER_ACTION_TYPE,
    bav: BANNER_ACTION_VALUE,
    ct: CTA_TEXT,
    cbt: CTA_BUTTON_TEXT,
    cat: CTA_ACTION_TYPE,
    cav: CTA_ACTION_VALUE
  }

  const INTEGRATION_CUSTOMIZATIONS = {
    colors: {
      primary: palette.purple, // any valid hex color; Default: #0050AA
      header: palette.smokyBlack, // any valid hex color; Default: #484848
      sub_header: palette.smokyBlack, // any valid hex color; Default: #6F6F6F
      button: palette.white, // any valid hex color; Default: #FFFFFF
      background: '#FCFBF8', // any valid hex color; Default: #FFFFFF
      highlight: palette.lightGrey // any valid hex color; Default: #DCDCDC
    },
    font: 'merriweather', // gotham || raleway || notosans || merriweather
    button: {
      text_style: 'capitalize', // capitalize || uppercase || lowercase
      border_radius: 8 // reccommeded range 0 - 30; < 30 has no effect
    },
    language: 'en-US', // en-US || es-US
    end_of_module: {
      // only used for deep_link widget type
      cta_text: 'You finished this module!', // Default: 'You finished this module!'
      cta_button_text: 'done', // Default: 'done'
      cta_post_message: 'module complete', // this is emitted to the parent app (this app/ your implementation) so you can control navigating see FLOW LISTENERS below
      banner_image: null, // image url for optional banner image
      banner_post_message: 'banner clicked' // this is emitted when a user taps the banner image.
    },
    icon_pack: 'classic' // classic || playful || clean - only used for skill_select widget type
  }

  // the customizations get url encoded and prepped to be added as a URL parameter
  const encodedIntegrationCustomizations = encodeURIComponent(JSON.stringify(INTEGRATION_CUSTOMIZATIONS))
  const encodedDeepLinkObject = encodeURIComponent(JSON.stringify(deepLinkCustomizations))

  return `
  <html>
    <head>
      <style>
        body {
          margin: 0px;
          background-color: #F6F2E9;
        }
      </style>
      <meta name="viewport" content="width=device-width, user-scalable=no">
    </head>
    <body>
     <iframe id="zogo-iframe" style="border: none" src=""></iframe>
     <span id="span-test" style="position: absolute; left: 0; background: red; font-size: 30px;"></span>
     <div
        id="zogo-preloader"
        style="
          overflow: hidden;
          display: flex;
          justify-content: center;
          background-color: #171b42;
          position: relative;
        "
      >
        <img
          src="https://ppwr.io/images/Logo-Zogo.png"
          alt="loader"
          id="zogo-preloader-loader"
          style="position: absolute; width: 128px; height: 128px; top: 50%; margin-top: -128px"
        />
        <img
          src="https://zogo-files.s3.amazonaws.com/app-resources/preloader-loader.gif"
          alt="loader"
          id="zogo-preloader-loader"
          style="position: absolute; top: 55%; height: 40px;"
        />
        <img
          src="https://zogo-files.s3.amazonaws.com/app-resources/splash.png"
          alt="preloader image"
          id="zogo-preloader-image"
          style="max-height: 100%; width: 100%; display: none;"


        />
      </div>

      <script>

        let startModuleTime;
        let endModuleTime;
        const span = document.getElementById('#span-test');
        
        let iframeSource = '${BASE_URL}?widget_type=${WIDGET_TYPE}&integration_customizations=${encodedIntegrationCustomizations}';
        if ('${WIDGET_TYPE}' === 'learn_and_earn' || '${WIDGET_TYPE}' === 'deep_link') {
          iframeSource += '&token=${TOKEN}';
        }
        if ('${WIDGET_TYPE}' === 'deep_link' || '${WIDGET_TYPE}' === 'anon_deep_link') {
          iframeSource += '&module_id=${MODULE_ID}&deep_link_customizations=${encodedDeepLinkObject}';
        }
        if ('${WIDGET_TYPE}' === 'anon_deep_link') {
          iframeSource += '&institution_id=${INSTITUTION_ID}';
        }

        const iframe = document.querySelector('#zogo-iframe');
        iframe.allow = 'clipboard-read; clipboard-write self ${BASE_URL}';
        iframe.style.width = '${IFRAME_WIDTH}';
        iframe.style.height = '0';
        iframe.src = iframeSource;

        const preloader = document.querySelector('#zogo-preloader');
        preloader.style.width = '${IFRAME_WIDTH}';
        preloader.style.height = '${IFRAME_HEIGHT}';

        if ('${ALTERNATIVE_PRELOADER_BACKGROUND_COLOR}') {
          preloader.style.backgroundColor = '${ALTERNATIVE_PRELOADER_BACKGROUND_COLOR}';
        }

        const preloaderImage = document.querySelector('#zogo-preloader-image');
        if ('${ALTERNATIVE_PRELOADER_IMAGE}') {
          preloaderImage.src = '${ALTERNATIVE_PRELOADER_IMAGE}';
        }
       
        
        // when receiving an appropriate message from the iframed zogo app, the preloader will be hidden and the zogo-iframe will be revealed
        window.addEventListener('message', function (event) {
          //document.getElementById("span-test").innerHTML=JSON.stringify(event.data);
          if (event.origin !== '${BASE_URL}') {
            return;
          }
          if (event.data === 'zogo ready') {
            startModuleTime = new Date();

            const rnWebView = window.ReactNativeWebView;
            const message = {
              type: 'startModule',
              startModuleTime
            }
            if(rnWebView) {
              rnWebView.postMessage(JSON.stringify(message))
            }

            preloader.style.height = '0';
            document.querySelector('#zogo-preloader-loader').style.visibility =
              'hidden';
            iframe.style.height = '${IFRAME_HEIGHT}';
          }
        });

        /*
        * when using the deep_link widget type this event listener will listen for the message letting
        * the parent app (your app) know the user has completed the deep linked module
        */
        window.addEventListener('message', function (event) {
          if (event.origin !== '${BASE_URL}') {
            return;
          }
          if (event.data === 'module complete') {
            const rnWebView = window.ReactNativeWebView;
            endModuleTime = new Date();
            const message = {
              type: 'finishModule',
              startModuleTime,
              endModuleTime
            }
            if(rnWebView) {
              rnWebView.postMessage(JSON.stringify(message))
            }
            // you will need to change this value if you set a custom postmessage
            // Add in appropriate parent app (your app) functionality for when the user has completed a deep link module
          }
        });

      </script>
    </body>
  </html>
`
}
